export default {
      id: "alcoholic_drinks_bottle-usage",
      viewBox: "0 0 30 33",
      url: __webpack_public_path__ + "img/icons.svg#alcoholic_drinks_bottle",
      toString: function () {
        return this.url;
      }
    }